import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { TimespanLabelsMap, TimespansType } from '@app/hcs-shared';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Timespans_MandatoryProps = {
    adapter: () => SimpleListAdapter([...TimespansType], item => _jsx(_Fragment, { children: TimespanLabelsMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Pick A Timespan'
};
export const Dropdown_Timespans = TS_DropDown.prepare(Timespans_MandatoryProps);
//# sourceMappingURL=ui-components.js.map